import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';
import { TabsPage } from '@pages/dashboard';
import { DrawerState } from 'ion-bottom-drawer';
import { DetailEmployeeActivity, DetailIdle, DetailTrackingActivity } from "../index";
import { cmpDepartmentList } from '@src/components/departmentList/cmp';
import { Storage } from '@ionic/storage';
import { Tracker } from '@providers/activity';
// import leaflet from 'leaflet';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { Observable } from 'rxjs';
import { cmpFilterKaryawan } from '@src/components/filterKaryawan/cmp';
import { DailyActivity } from '@src/components/Content';
// import * as d3 from 'd3';
declare var d3;
@Component({
  selector: 'tracking-web-activity',
  templateUrl: 'page.html'
})
export class TrackingWeb {

  berita:any = '';
  loading : any;
  url = this.api.url + '/index.php/activity/Location/tracking_all_employee';
  data = {
    history:[],
    employee_name : this.userApi.data.name,
    selected:{
      department:[]
    },
    today:{
      hari : "",
      total_record:0,
    },
    user:{
      lat : 0,
      lng : 0,
    },
    style : 'mapbox://styles/mapbox/outdoors-v9',
    // style : 'mapbox://styles/hanafiq/ck29yeqbn3svi1cpulkddp8oh',
    // style : 'mapbox://styles/hanafiq/ck6n4z4vb0qlw1iqqdsyvgrkf',
  };
  state = {
    skeleton : true,
    selected_marker : 'employee',
    selected_history : 'none',
    employee_selected : this.userApi.data.user_name,
  };

  today = this.helper.getToday();
  parameter : any = {
    employee_id : this.userApi.data.employee_id,
    employee_code : this.userApi.data.code,
    date : "",
    id : this.userApi.data.employee_id,
    flag : "employee"
  }
  map = mapboxgl.Map;
  marker: any = [];
  drawerOptions: any;
  fileTransfer: FileTransferObject = this.transfer.create();
  // @ViewChild('widgetSearch') private searchBar: Searchbar;
  // @ViewChild('map') mapContainer: ElementRef;
  // map: any;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private modalCtrl     : ModalController,
    private storage       : Storage,
    public trackerProvider   : Tracker,
    private geolocation       : Geolocation,
  ) {
      // this.getAsset();
      this.drawerOptions = {
        handleHeight: 0,
        thresholdFromBottom: 200,
        thresholdFromTop: 200,
        bounceBack: false,
        has_event_panup: true,
        event_panup : () => {
          document.getElementById('area-asset').style.height = "calc(100vh - 170px)";
        },
        has_event_pandown:true,
        event_pandown : () => {
          document.getElementById('area-asset').style.height = "calc(40vh - 100px)";
        },
      };
      mapboxgl.accessToken = this.userApi.tokenMapbox;
      //bikin interval buat check data terbaru setiap 15 detik
    }
    
    ionViewDidEnter() {
      let me = this;
      this.data.user.lat = -6.240275;
      this.data.user.lng = 106.819667;
      this.getDataEmployee(this.userApi.data.Employee_ID);
      this.loadmap();
    //   this.geolocation.getCurrentPosition().then((data) => {
    //     this.data.user.lat = data.coords.latitude;
    //     this.data.user.lng = data.coords.longitude;
    //     // this.getUpdateLocation();
    //   });
    }

    loadmap() {
      let me = this;
      this.map = new mapboxgl.Map({
        container: 'map',
        style: this.data.style,
        attributionControl:false,
        zoom: 10,
        center: [this.data.user.lng , this.data.user.lat],
      });
      
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
        enableHighAccuracy: true,
        zoom:0
        },
        trackUserLocation: true
      }));
      // var url = 'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_ports.geojson';
      this.map.on('load',() => {
        //with animation 
        this.map.loadImage('./assets/img/location_orange.png',function(error, image) {
          if (error) throw error;
          me.map.addImage('marker-custom', image);
          me.map.loadImage('./assets/img/marker_people.png',(error,img) => {
            if (error) throw error;
            me.map.addImage('marker-people', img);
            me.map.addSource('points', {
              'type': 'geojson',
              'data': me.url+'?flag='+me.state.selected_marker+'&employee_id='+me.parameter.employee_id+'&employee_code='+me.parameter.employee_code+'&asset_id='+me.parameter.asset_id,
              "cluster": true,
              "clusterMaxZoom": 16, // Max zoom to cluster points on
              "clusterRadius": 40 
            });
            me.map.addLayer({
              id: 'clusters',
              type: 'circle',
              source: 'points',
              filter: ['has', 'point_count'],
              paint: {
              // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
              // with three steps to implement three types of circles:
              //   * Blue, 20px circles when point count is less than 100
              //   * Yellow, 30px circles when point count is between 100 and 750
              //   * Pink, 40px circles when point count is greater than or equal to 750
              'circle-color': [
              'step',
              ['get', 'point_count'],
              '#51bbd6',
              100,
              '#f1f075',
              750,
              '#f28cb1'
              ],
              'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40
              ]
              }
              });
               
              me.map.addLayer({
              id: 'cluster-count',
              type: 'symbol',
              source: 'points',
              filter: ['has', 'point_count'],
              layout: {
              'text-field': '{point_count_abbreviated}',
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 30
              }
              });
               
            me.map.addLayer({
              id: 'unclustered-point',
              type: 'symbol',
              source: 'points',
              filter: ['!', ['has', 'point_count']],
              'layout': {
                // get the icon name from the source's "icon" property
                // concatenate the name to get an icon from the style's sprite sheet
                'icon-image': 'marker-people',
                // get the title name from the source's "title" property
                'text-field': ['get', 'title'],
                'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                'text-offset': [0, 0.6],
                'text-anchor': 'top'
              },
            });
               
              // inspect a cluster on click
            me.map.on('click', 'clusters', function(e) {
              var features = me.map.queryRenderedFeatures(e.point, {
              layers: ['clusters']
              });
              var clusterId = features[0].properties.cluster_id;
              me.map.getSource('points').getClusterExpansionZoom(
              clusterId,
              function(err, zoom) {
              if (err) return;
               
              me.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
              });
              }
              );
            });
               
              

            me.map.on('click', 'unclustered-point', function(e) {
              var coordinates = e.features[0].geometry.coordinates.slice();
              var description = e.features[0].properties.description;
               
              // Ensure that if the map is zoomed out such that multiple
              // copies of the feature are visible, the popup appears
              // over the copy being pointed to.
              while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
              }
               
              // new mapboxgl.Popup()
              //   .setLngLat(coordinates)
              //   .setHTML(description)
              //   .addTo(me.map);


                //get history employee
                // console.log(e.features[0].properties.employee_id);
                me.getDataEmployee(e.features[0].properties.employee_id);
                me.data.employee_name = e.features[0].properties.employee_name;
                me.parameter.id = e.features[0].properties.employee_id;
              });
               
              // Change the cursor to a pointer when the mouse is over the points layer.
              me.map.on('mouseenter', 'points', function() {
                me.map.getCanvas().style.cursor = 'pointer';
              });
               
              // Change it back to a pointer when it leaves.
              me.map.on('mouseleave', 'points', function() {
                me.map.getCanvas().style.cursor = '';
              });
            // window.setInterval(function() {
            //     let options = {
            //       zoom : false,
            //     };
            //     me.update_location(options.zoom);
            // }, 15000);
          }); 
        });

      });    
    }

  update_location(zoom = true){
    let me = this
    d3.json(me.url+'?flag='+me.state.selected_marker+'&employee_id='+me.parameter.employee_id+'&employee_code='+me.parameter.employee_code+'&asset_id='+me.parameter.asset_id,(err, data) => {
      if (err) throw err;
      me.map.getSource('points').setData(data);
      let icon = me.state.selected_marker == 'employee' ? 'marker-people' : 'marker-custom';
      me.map.setLayoutProperty("points","icon-image",icon);
      if (data.features.length == 1) {
        console.log("fly to coordinates");
        me.fly_map_to_coordinates(data.features[0].geometry.coordinates,zoom);
      }
    });
  }

  get_location_employee(employee_id){
    this.loading = this.helper.showLoading("Loading..");
    this.trackerProvider.getEmployeeLocation({
      id : employee_id
    }).subscribe((resp?:any) => {
      if(resp.success){
        this.fly_map_to_coordinates([resp.data.longitude,resp.data.latitude],true);
        this.getDataEmployee(resp.data.employee_id);
        // console.log(this.state,this.data.employee);
        try {
          this.loading.dismiss();
          
        } catch (error) {}
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        setTimeout(() => {
          this.loading.dismiss();
        }, 500);
      } catch (error) {
        
      }
    }); 
  }

  //load data employee
  getDataEmployee(employee_id){
    this.state.skeleton = true;
    this.trackerProvider.getRekapEmployeeLocation({
      id : employee_id
    }).subscribe((resp?:any) => {
      if(resp.success){
        this.data.history = resp.data.history;
        this.data.today = resp.data.today;
        // console.log(this.state,this.data.employee);
        try {
          // this.loading.dismiss();
          setTimeout(() => {
            this.state.skeleton = false;
          }, 500);
        } catch (error) {}
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        setTimeout(() => {
          this.state.skeleton = false;
        }, 500);
      } catch (error) {
        
      }
    }); 
  }

  fly_map_to_coordinates(coordinates,zoom = true){
   if (zoom) {
    this.map.flyTo({
      center: coordinates,
      zoom: 15,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
   }else{
    this.map.flyTo({
      center: coordinates,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
   }
  }

  fly_map_indonesia(){
    this.map.flyTo({
      center: [
        106.819656,
        -6.240224
      ],
      zoom: 5,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }

  showKaryawan(){
    let me = this;
    this.loading = this.helper.showLoading("Proses...");
    let params = {
      id:this.userApi.data.Employee_ID,
      active_tab:"none",
    };
    this.repositoryProvider.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {active_tab:params.active_tab,karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Team Profile",level:resp.data.level}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.parameter.employee_id = me.userApi.data.employee_id;
              me.parameter.id = me.userApi.data.employee_id;
              me.parameter.employee_code = me.userApi.data.code;
              me.state.employee_selected = me.userApi.data.user_name;
            }else{
              me.parameter.employee_id = karyawan.id;
              me.parameter.id = karyawan.id;
              me.parameter.employee_code = karyawan.nik;
              me.state.employee_selected = karyawan.employee_name;
            }
            // this.showLoading();
            me.get_location_employee(me.parameter.employee_id);
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  drawRouteHistory(data){
    let me = this;
    this.state.selected_history = data.id;
    let mapLayer = this.map.getLayer('route');
    this.marker.forEach(row => {
      row.remove();
    });
    if(typeof mapLayer !== 'undefined') {
      this.map.removeLayer('route').removeSource('route');
    }
    let coordinates = [];
    let history = JSON.parse(data.geolocation);
    let routes = history.points;
         
    // start by showing just the first coordinate
    routes.forEach(position => {
      console.log(position);
      coordinates.push([position.longitude,position.latitude]);
    });

    console.log("awal coordinat",coordinates[0], "data coordinat => ",coordinates);
    let data_source = {
      'type': 'Feature',
      'properties': {},
      'geometry': {
        'type': 'LineString',
        'coordinates': coordinates[0]
      }
    };

    let mark_start = document.createElement('div');
    mark_start.className = 'marker-red';
    let a = new mapboxgl.Marker(mark_start).setLngLat(coordinates[1]).addTo(this.map);
    this.marker.push(a);
      
    // add it to the map
    me.map.addSource('route', { type: 'geojson', data: data_source });
    this.map.addLayer({
      'id': 'route',
      'type': 'line',
      'source': 'route',
      'layout': {
        'line-join': 'round',
        'line-cap': 'round'
      },
      'paint': {
        'line-color': '#f49c1f',
        'line-width': 8,
        'line-opacity': 0.75,
      }
    });
      
    // setup the viewport
    me.map.jumpTo({ 'center': coordinates[0], 'zoom': 15 });
    me.map.setPitch(30);
      
    // on a regular basis, add more coordinates from the saved list and update the map
    var i = 1;
    var timer = window.setInterval(function() {
      if (i < coordinates.length) {
        data_source.geometry.coordinates.push(
          coordinates[i]
        );
        me.map.getSource('route').setData(data_source);
        me.map.panTo(coordinates[i]);
        i++;
      } else {
        //bikin marker doang
        let mark_end = document.createElement('div');
        mark_end.className = 'marker-orange';
        let b = new mapboxgl.Marker(mark_end).setLngLat(coordinates[coordinates.length - 1]).addTo(me.map);
        me.marker.push(b);
        //selesai bikin marker
        window.clearInterval(timer);
      }
    }, 50);


    
    // this.map.addSource('route', {
    //   'type': 'geojson',
    //   'data': {
    //     'type': 'Feature',
    //     'properties': {},
    //     'geometry': {
    //       'type': 'LineString',
    //       'coordinates': coordinates
    //     }
    //   }
    // });
    // this.map.addLayer({
    //   'id': 'route',
    //   'type': 'line',
    //   'source': 'route',
    //   'layout': {
    //     'line-join': 'round',
    //     'line-cap': 'round'
    //   },
    //   'paint': {
    //     'line-color': '#f49c1f',
    //     'line-width': 8
    //   }
    // });

    

    //camera view position kemana
    // this.map.flyTo({
    //   center:coordinates[Math.ceil(coordinates.length/2) -1],
    //   zoom: 16,
    //   speed: 0.9,
    //   curve: 1,
    //   easing(t) {
    //     return t;
    //   },
    //   essential: true
    // });
  }

  showActivity(item){
    this.parameter.date = item.date;
    this.loading = this.helper.showLoading("Loading...");
    this.repositoryProvider.getDailyActivity(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    if(resp.success){
      let activityPopup = this.modalCtrl.create(DailyActivity, {data : resp.data,hari : item.hari }, {cssClass: 'select-modal',enableBackdropDismiss:false });
      activityPopup.present();
    }
  },(err) => {
    this.helper.presentToast('Error');
    try {
      this.loading.dismiss();
    } catch (error) {
      
    }
  });  
    
  }

  loadAllEmployee(){
    let me = this;
    let mapLayer = this.map.getLayer('route');
    this.marker.forEach(row => {
      row.remove();
    });
    if(typeof mapLayer !== 'undefined') {
      this.map.removeLayer('route').removeSource('route');
    }
    me.map.setPitch(0);
    d3.json(me.url+'?flag='+me.state.selected_marker+'&employee_id='+me.parameter.employee_id+'&employee_code='+me.parameter.employee_code+'&asset_id='+me.parameter.asset_id,(err, data) => {
      if (err) throw err;
      me.map.getSource('points').setData(data);
      let icon = me.state.selected_history= 'none';
      me.map.setLayoutProperty("points","icon-image",icon);
      this.map.flyTo({
        center: [this.data.user.lng , this.data.user.lat],
        zoom: 10,
        speed: 1,
        curve: 1,
        easing(t) {
          return t;
        },
        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      });
    });  
  }

  generate_element(state,data,generated_class_label,generated_class_button){
    let element = `
        <div class="background-biru-muda" style="width:100%;padding: 1px 10px;" >
          <p class="text-abu">`+ data.string_date+`<p >
          <div style="display: inline-grid;grid-template-columns:50% 50%;width:100%;">
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">In</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeIn,'').substring(0,5)+`
                </div>
              </div>
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">Out</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeOut,'').substring(0,5)+`
                </div>
              </div>
          </div> 
          <p class="text-abu" style="font-size:12px;">
            Min Late <span style="color:black"> `+this.helper.ifvalnull(data.MinLate,'')+` </span>
          </p>
        </div> 
        `;
        if (state=='employee') {
          element += `
          <div style="width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <span style="font-size: 13px;"> Attachment </span>
                <p class="text-biru `+generated_class_label+`" style="margin: 0px;font-size: 12px;"> `+this.helper.ifvalnull(data.file_name,'')+`</p>
            </div>
          </div>
          <div style="width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <p style="font-size: 13px;"> Productivity : <span class="text-abu">`+this.helper.ifvalnull(data.Productivity,'0').replace("%","")+`% </span></p> 
            </div>
            <div>
                <p style="font-size: 13px;"> Notes : <span class="text-abu">`+this.helper.ifvalnull(data.notes,'')+`</span></p> 
            </div>
          </div>
          <button class="swal-button swal-button--confirm close-sweetalert-`+generated_class_button+`">Ok</button>`;
        }else{
          element += `
          <div style="display:inline-grid;grid-template-columns: calc(100% - 50px) 50px;width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <span style="font-size: 13px;"> Attachment </span>
                <p class="text-biru `+generated_class_label+`" style="margin: 0px;font-size: 12px;"> `+this.helper.ifvalnull(data.file_name,'')+`</p>
            </div>
            <div style="text-align: right;">
                <button class="btn-camera  item-button button button-ios button-default button-default-ios" style="background: #b5b9bc !important;font-size: 20px !important;padding: 0px !important;height: 30px !important;width: 40px;"><span
                        class="button-inner">
                        <ion-icon name="custom-camera" role="img" class="`+generated_class_button+` btn-capture-img icon icon-ios ion-ios-custom-camera"
                            aria-label="custom camera" ng-reflect-name="custom-camera"></ion-icon>
                    </span>
                    <div class="button-effect"></div>
                </button> 
            </div>
          </div>
          <div style="padding-top:10px">
            <label class="text-abu" style="padding-right:10px">Productivity</label>
            <input style="width: 40px;-webkit-appearance: none;background-color: #ebebeb;font-size: 14px;box-sizing: border-box;border: 1px solid rgba(0,0,0,.14);border-radius: 2px;transition: border-color .2s;
            padding: 5px !important;" max="3" type="number" name="productivity" id="input-productivity" value="`+
            this.helper.ifvalnull(data.Productivity,'0').replace("%","")+`"> <span class="text-abu">%</span>
          </div>
          <textarea class="swal-content__textarea" rows="7" id="notes-change-productivity" placeholder="Enter Notes Here.." style="margin: 10px;width: calc(100% - 20px);">`+this.helper.ifvalnull(data.notes,'')+`</textarea>
          `;
        }
        return element;
  }


  // asdkajsdljaskl d


  findEmployee(){
    this.state.selected_marker = 'employee';
    let me = this;
    let icon = me.state.selected_marker == 'employee' ? 'marker-people' : 'marker-custom';
    me.map.setLayoutProperty("points","icon-image",icon);

    this.update_location();
  }

  
  
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

  detailAsset(data){
    this.nav.setRoot(DetailTrackingActivity,{data:data});
  }

  showListDepartment(){
    let me = this;
  }

  addSingleMarker(item,class_mark="marker-orange"){
    let el = document.createElement('div');
    el.className = class_mark;
    
    // make a marker for each feature and add to the map
    let mark =  new mapboxgl.Marker(el)
      .setLngLat([item.longitude,item.latitude])
      .addTo(this.map);
    this.marker.push(mark);
    this.map.flyTo({
      center: [
        item.longitude,
        item.latitude
      ],
      zoom: 15,
      speed: 0.9,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }

  addManyMarker(item){
    item.forEach(row => {
      var el = document.createElement('div');
      if (row.flag == 'employee') {
        el.className = 'marker-people';
      }else{
        el.className = 'marker-motor';
      }
      // make a marker for each feature and add to the map
      let mark =  new mapboxgl.Marker(el)
        .setLngLat([row.longitude,row.latitude])
        .addTo(this.map);
      this.marker.push(mark);
    });
    this.map.flyTo({
      center: [
        106.819656,
        -6.240224
      ],
      zoom: 10,
      speed: 0.9,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/activity/tracking_web/page.ts